import NewsFeed from "../NewsFeed"
const AllNewsFeed = () => {
  return <NewsFeed forAllTrends={true} />
}

export default AllNewsFeed
